module.exports = __webpack_public_path__ + "4-78.jpg?e3a9ed5f24d95893f82237e8af245de3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/4-78.jpg
// module id = 159
// module chunks = 0